// @flow

export { create as default } from './js/factory';

export {
	workflowStatuses as phoneConfirmationStatuses,
	modeTypes as phoneConfirmationModes,
} from './js/dictionary';

export type {
	CreationOptions as PhoneConfirmationOptions,
	IController as IPhoneConfirmation,
	IConfirmationResult as PhoneConfirmationResult,
} from './js/contracts';
